import React, { useEffect, useRef, useState } from 'react';
import TextField from "@material-ui/core/TextField";
import { Field, Form, Formik } from "formik";
import Typography from "@material-ui/core/Typography";
import { Button } from "@material-ui/core";
import { themeButtons } from "../../../css/themeButtons";
import Link from "@material-ui/core/Link";
import { NavLink } from "react-router-dom";


const FastAbout = (props) => {
  const [unsavedPage, toggleUnsavedPage] = useState(false)

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [])

  const { description, goPage, objectId, savePage, history, isMobile } = props

  //валидация формы
  const validation = (value) => {
    //если значения формы отличаются от начальных то показывать кнопку сохранить страницу
    if (JSON.stringify(formRef.current.initialValues) != JSON.stringify(value)) {
      toggleUnsavedPage(true)
    } else {
      toggleUnsavedPage(false)
    }
    const error = {}
    if (!value.description) {
      error.description = "Поле не может быть пустым"
    }
    if (value.description.length >= 2000) {
      error.description = "Поле не может содержать более 2000 символов"
    }
    return error
  }


  //реф формы
  const formRef = useRef()


  //переназначенный submit формы
  const handleSubmit = async (values) => {
    if (formRef.current) {
      formRef.current.handleSubmit()
    }
  }


  //сохранение страницы
  const onSubmit = async (values) => {
    if (unsavedPage) {
      toggleUnsavedPage(false)
      await savePage({ object: objectId, section: "description", data: values })
    }

    goPage("photos")
  }

  const backToObjectsList = () => {
    history.replace("/lk")
  }


  const buttons = themeButtons()
  return (
    <div className="stepByStepWrp">
      <div className="stepByStepWrp__header">
        <Typography variant="h5" component="h5" className="stepByStepWrp__title">Добавьте живое описание
          объекта</Typography>
      </div>
      <div className="stepByStepWrp__body">
        <div className="navbar__object-id badge bg-success me-0 me-sm-2 mb-3">id: {objectId}</div>
        <div className="mb-3">
          <Link component={NavLink} target="_blank"
                to={`/mail-pages/1/`}
                className={`btn ${buttons.btnGreen}`} variant="outlined">Рекомендации по заполнению</Link>
        </div>
        <div className="alert alert-warning mb-3">
          Расскажите своими словами о вашем Объекте
        </div>
        <div id="description">
          <div className="row">
            <div className="col-12 mb-2">
              <Formik innerRef={formRef}
                      enableReinitialize
                      initialValues={{ description: description ? description : '' }}
                      validate={validation}
                      onSubmit={onSubmit}>
                {({ errors, values, touched }) => (
                  <Form>
                    <div className="d-flex">
                      <Field name="description">
                        {({ field, form }) => (
                          <TextField
                            {...field}
                            label="Описание объекта"
                            multiline
                            fullWidth
                            rows={isMobile ? 10 : 15}
                            variant="outlined"
                            inputProps={{ maxLength: 2000 }}
                            error={Boolean(errors.description && touched.description)}
                            helperText={`${errors.description && touched.description ? errors.description : `${values["description"].length ? values["description"].length : 0}/2000`}`}
                          />
                        )}
                      </Field>
                    </div>
                  </Form>

                )}
              </Formik>
            </div>


          </div>

        </div>
      </div>


      <div className="stepByStepWrp__actions">
        <Button className={`btn`} onClick={backToObjectsList}>Назад к объектам</Button>
        <Button className={`btn ${buttons.btnGreen}`} disabled={!unsavedPage && !description}
                onClick={handleSubmit}>Сохранить и продолжить</Button>
      </div>
    </div>


  )
}


export default FastAbout;
